import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatRadioButton } from '@angular/material/radio';
import { DefaultFormValueControl } from '@coin/shared/core/util-helpers';

@Component({
  selector: 'coin-v2-radio-button',
  imports: [MatRadioButton],
  templateUrl: './v2-radio-button.component.html',
  styleUrl: './v2-radio-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2RadioButtonComponent extends DefaultFormValueControl<boolean> {
  readonly color = input<ThemePalette>('primary');
  readonly label = input<string>();
  readonly name = input<string>();
}
